import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';

import BookingFormSelect from './BookingFormSelect';

class BookingFormEmployeeInput extends Component {
  handleIconClick = event => {
    const { showEmployeesOfPosition } = this.props;
    showEmployeesOfPosition(event.currentTarget.name);
  };

  render() {
    const {
      eligibleEmployees,
      onFormEmployeeSelect,
      positionTitle,
      label,
      showEmployeesOfPosition,
    } = this.props;

    return (
      <>
        <Grid item xs={3} display="flex" className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {label}
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <BookingFormSelect
            options={eligibleEmployees}
            position={positionTitle}
            onChange={onFormEmployeeSelect}
            onFocus={showEmployeesOfPosition}
          />
        </Grid>
        <Grid item xs={1} className="bookingListIcon">
          <IconButton
            className="listIconBtn"
            color="secondary"
            aria-label="model-list-btn"
            name={positionTitle}
            onClick={this.handleIconClick}
          >
            <ListIcon />
          </IconButton>
        </Grid>
      </>
    );
  }
}

BookingFormEmployeeInput.propTypes = {
  eligibleEmployees: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
  onFormEmployeeSelect: PropTypes.func.isRequired,
  positionTitle: PropTypes.string.isRequired,
  showEmployeesOfPosition: PropTypes.func.isRequired,
}

export default BookingFormEmployeeInput;
